import request from '@/utilsCloud/request'
import port from './port'

// 获取公共课程库列表菜单
export function getCourseHomeList(query) {
  return request({
    url: port.course + '/home/getCourseHomeList',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/apiCloud/CateSelect.js